import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import * as _ from 'lodash';
import { AuthService } from 'src/app/services/auth.service';

@Component({
  selector: 'app-page-activity-estimating-monthly-income-nancy-rw',
  templateUrl: './page-activity-estimating-monthly-income-nancy-rw.component.html',
  styleUrls: ['./page-activity-estimating-monthly-income-nancy-rw.component.css','../module-page-rw/module-page-rw.component.css']
})
export class PageActivityEstimatingMonthlyIncomeNancyRwComponent implements OnInit {

  @Input()
  backTitle = 'Back';

  @Input()
  nextTitle = 'Next';

  @Input()
  delay = true;

  @Output()
  back = new EventEmitter<Event>();

  @Output()
  next = new EventEmitter<Event>();

  flag = false;
  checked = false; // compare with keys

  model = {
    income: {
      row1: { value1: '', value2: '', value3: '' },
      row2: { value1: '', value2: '', value3: '' },
      row3: { value1: '', value2: '', value3: '' },
      row4: { value1: '', value2: '', value3: '' },
      row5: { value1: '', value2: '', value3: '' },
      row6: { value1: '', value2: '', value3: '' },
      row7: { value1: '', value2: '', value3: '' },
      row8: { value1: '', value2: '', value3: '' },
      row9: { value1: '', value2: '', value3: '' },
      row10: { value1: '', value2: '', value3: '', other: '' },
      row11: { value1: '', value2: '', value3: '', subtotal: true },
    },
    assistance: {
      row1: { value1: '', value2: '', value3: '' },
      row2: { value1: '', value2: '', value3: '' },
      row3: { value1: '', value2: '', value3: '' },
      row4: { value1: '', value2: '', value3: '' },
      row5: { value1: '', value2: '', value3: '' },
      row6: { value1: '', value2: '', value3: '' },
      row7: { value1: '', value2: '', value3: '' },
      row8: { value1: '', value2: '', value3: '' },
      row9: { value1: '', value2: '', value3: '', other: '' },
      row10: { value1: '', value2: '', value3: '', subtotal: true },
    },
    otherResources: {
      row1: { value1: '', value2: '', value3: '', other: '' },
      row2: { value1: '', value2: '', value3: '', other: '' },
      row3: { value1: '', value2: '', value3: '', subtotal: true },
      row4: { value1: '', value2: '', value3: '', total: true },
    },
  };

  keys = {
    income: {
      row1: { value1: '$1,020', value2: '', value3: '$1,020' },
      row2: { value1: '', value2: '', value3: '' },
      row3: { value1: '', value2: '', value3: '' },
      row4: { value1: '', value2: '', value3: '' },
      row5: { value1: '', value2: '', value3: '' },
      row6: { value1: '', value2: '', value3: '' },
      row7: { value1: '', value2: '', value3: '' },
      row8: { value1: '', value2: '', value3: '' },
      row9: { value1: '', value2: '', value3: '' },
      row10: { value1: '', value2: '', value3: '', other: '' },
      row11: { value1: '$1,020', value2: '', value3: '$1,020' },
    },
    assistance: {
      row1: { value1: '', value2: '$278', value3: '$278' },
      row2: { value1: '', value2: '', value3: '' },
      row3: { value1: '', value2: '', value3: '' },
      row4: { value1: '', value2: '$279', value3: '$279' },
      row5: { value1: '', value2: '$99', value3: '$99' },
      row6: { value1: '', value2: '', value3: '' },
      row7: { value1: '', value2: '', value3: '' },
      row8: { value1: '', value2: '', value3: '' },
      row9: { value1: '', value2: '', value3: '', other: '' },
      row10: { value1: '', value2: '$656', value3: '$656' },
    },
    otherResources: {
      row1: { value1: '', value2: '', value3: '', other: '' },
      row2: { value1: '', value2: '', value3: '', other: '' },
      row3: { value1: '', value2: '', value3: '' },
      row4: { value1: '$1,020', value2: '$656', value3: '$1,676' },
    },
  }

  correct = JSON.parse(JSON.stringify(this.model)); // clone empty
  correctAll = false;

  previewByAdmin = this.auth.isSuperAdmin;
  // previewByAdmin = false;

  constructor(private auth: AuthService) { }

  ngOnInit(): void {
    // this.check();
    this.calcTotals();
  }

  goBack(event?: Event) {
    if (event?.defaultPrevented) return false;
    this.back.emit(event);
    return true;
  }

  goNext(event?: Event) {
    if (event?.defaultPrevented) return false;
    this.next.emit(event);
    return true;
  }

  setFlag() {
    this.flag = true;
  }

  resetFlag() {
    this.flag = false;
  }

  activityOneCompleted() {
    if (!this.delay) return true;

    const total = this.model.otherResources.row4;
    return total.value1 !== '$0' || total.value2 !== '$0' || total.value3 !== '$0';
  }

  check(event?: Event) {
    if (this.checked) return true;
    if (event?.defaultPrevented) return false;

    const model   = this.model as any;
    const keys    = this.keys as any;
    const correct = this.correct as any;
    const compare = ['value1', 'value2', 'value3'];

    this.correctAll = true; // TBD below

    for (const section in model) {
      for (const row in model[section]) {
        const answer  = model[section][row];
        const key     = keys[section][row];

        for (const value of compare) {
          if (!(value in answer)) {
            continue;
          }

          const a    = this.parseAmount(answer[value]) || '';
          const k    = this.parseAmount(key[value]) || '';
          const diff = a !== k;

          correct[section][row][value] = diff ? key : '';

          if (diff) {
            this.correctAll = false;
          }

          if (diff && !a) {
            answer[value] = '$0';
          }
        }
      }
    }

    this.checked = true;

    return false;
  }

  calcTotals(): void {
    const model = this.model as any;
    const subtotals = [] as any[];

    for (const section in model) {
      const rows: any[] = Object.values(model[section]);
      const subtotal = rows.find(r => r.subtotal);
      const total = rows.find(r => r.total);
      const input = rows.filter(r => !r.total && !r.subtotal);

      if (subtotal) {
        subtotal.value1 = this.sumAmountsBy(input, 'value1');
        subtotal.value2 = this.sumAmountsBy(input, 'value2');
        subtotal.value3 = this.sumAmountsBy(input, 'value3');
        subtotals.push(subtotal);
      }

      if (total) {
        total.value1 = this.sumAmountsBy(subtotals, 'value1');
        total.value2 = this.sumAmountsBy(subtotals, 'value2');
        total.value3 = this.sumAmountsBy(subtotals, 'value3');
      }
    }
  }

  private parseAmount(value: string) {
    if (!value && typeof value !== 'number') return NaN;
    const amount = parseFloat(String(value || '').replace(/[^\d\.]+/g, ''));
    return isNaN(amount) ? amount : amount.toFixed(2);
  }

  private sumAmountsBy(rows: any[], property: string) {
    return '$' + _(rows).filter(r => r[property]).map(r => +this.parseAmount(r[property]) || 0).sum().toLocaleString('en-US');
  }
}
